const GET_PDP_BUNDLE = `
query pdpBundleBox($slug: String){
    pdpBundleBox(slug:$slug){
       edges {
        node {
          id
          title
          description 
          bundles{
          id
          totalNoProducts
          heroImage
          heroImage1
          heroImage2
          bundleProducts{
            id
            shopifyProductId
              
          }
        }
        }
      }
    }
  }
`;

export { GET_PDP_BUNDLE };
